<script>
import $ from 'domtastic';

export default {
  props: {
    hidden: [Boolean, String],
  },
  data: () => ({
    showGradient: false,
  }),
  mounted() {
    $(this.$el).on('scroll', this.$_scroll);
  },
  beforeDestroy() {
    $(this.$el).off('scroll', this.$_scroll);
  },
  methods: {
    $_scroll() {
      this.showGradient = this.$el.scrollLeft > 0;
    },
  },
};
</script>

<template lang='pug'>
div
  slot
  template(v-if='!hidden')
    .vertical-gradient.vertical-gradient--right
    .vertical-gradient.vertical-gradient--left(v-show='showGradient')
</template>

<style>
@import '~import/index';

.vertical-gradient {
  position: absolute;
  top: 0;
  height: 100%;
  width: 2rem;

  &--right {
    right: 0;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), white);
  }

  &--left {
    left: 0;
    background: linear-gradient(to right, white, rgba(255, 255, 255, 0));
  }

  @include mq(mf-md) {
    display: none;
  }
}
</style>